/*
  Gnome pop: when a link marked data-gnome-pop="<character>" is tapped, a cartoon gnome head pops up with a
  RUFF! / MEOW! sign and its bark or meow plays, then the link opens as usual a moment later (a page change
  would cut the sound off).

  Characters: black-doodle, frenchie-beige, frenchie-black, gray-cat, black-cat. Each needs
  assets/gnome-pop-<character>.png; sounds are gnome-pop-ruff.mp3 / gnome-pop-meow.mp3 and signs are
  gnome-pop-sign-ruff.png / gnome-pop-sign-meow.png.

  Links that cannot carry the attribute (theme sections) can be listed before this script loads:
    window.gnomePopLinks = [{ selector: '.rich-text a[href*="some-page"]', pop: 'black-doodle' }];

  If anything fails the link simply opens.
*/
(function () {
  if (window.__gnomePopLoaded) return;
  window.__gnomePopLoaded = true;

  var script = document.currentScript;
  var base = script && script.src ? script.src.replace(/[^/]*$/, '') : '';
  if (!base) return;

  var CATS = { 'gray-cat': true, 'black-cat': true };
  var HOLD_MS = { ruff: 650, meow: 850 };
  var sounds = {};
  var busy = false;

  function soundFor(character) {
    return CATS[character] ? 'meow' : 'ruff';
  }

  function audio(name) {
    if (!sounds[name]) {
      sounds[name] = new Audio(base + 'gnome-pop-' + name + '.mp3');
      sounds[name].preload = 'auto';
    }
    return sounds[name];
  }

  function characterFor(link) {
    var character = link.getAttribute('data-gnome-pop');
    if (character) return character;
    var extra = window.gnomePopLinks || [];
    for (var i = 0; i < extra.length; i++) {
      if (link.matches(extra[i].selector)) return extra[i].pop;
    }
    return '';
  }

  function addStyles() {
    if (document.getElementById('gnome-pop-styles')) return;
    var style = document.createElement('style');
    style.id = 'gnome-pop-styles';
    style.textContent =
      '.gnome-pop{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;' +
      'pointer-events:none;background:rgba(238,224,203,.55)}' +
      '.gnome-pop__stage{position:relative;animation:gnome-pop-in .45s cubic-bezier(.2,1.6,.4,1) both}' +
      '.gnome-pop__head{display:block;height:min(52vh,34rem);width:auto;filter:drop-shadow(0 1rem 2rem rgba(17,21,28,.3))}' +
      '.gnome-pop__sign{position:absolute;top:8%;left:62%;width:min(40vw,20rem);height:auto;' +
      'animation:gnome-pop-sign .35s .12s cubic-bezier(.2,1.8,.4,1) both}' +
      '@keyframes gnome-pop-in{from{transform:translateY(60%) scale(.4);opacity:0}to{transform:none;opacity:1}}' +
      '@keyframes gnome-pop-sign{from{transform:scale(0) rotate(-20deg)}to{transform:scale(1) rotate(8deg)}}' +
      '@media (prefers-reduced-motion:reduce){.gnome-pop__stage,.gnome-pop__sign{animation:none}.gnome-pop__sign{transform:rotate(8deg)}}';
    document.head.appendChild(style);
  }

  function clear() {
    var old = document.querySelector('.gnome-pop');
    if (old) old.remove();
    busy = false;
  }

  function show(character) {
    var name = soundFor(character);
    addStyles();
    var overlay = document.createElement('div');
    overlay.className = 'gnome-pop';
    overlay.setAttribute('aria-hidden', 'true');
    var stage = document.createElement('div');
    stage.className = 'gnome-pop__stage';
    var head = document.createElement('img');
    head.className = 'gnome-pop__head';
    head.alt = '';
    head.src = base + 'gnome-pop-' + character + '.png';
    var sign = document.createElement('img');
    sign.className = 'gnome-pop__sign';
    sign.alt = '';
    sign.src = base + 'gnome-pop-sign-' + name + '.png';
    stage.appendChild(head);
    stage.appendChild(sign);
    overlay.appendChild(stage);
    document.body.appendChild(overlay);
    try {
      var sound = audio(name);
      sound.currentTime = 0;
      var played = sound.play();
      if (played && played.catch) played.catch(function () {});
    } catch (err) {}
    return HOLD_MS[name];
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link || event.defaultPrevented) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (link.target && link.target !== '_self') return;
    var character = characterFor(link);
    if (!character || character === 'none') return;
    event.preventDefault();
    if (busy) return;
    busy = true;
    var hold = 0;
    try {
      hold = show(character) || 0;
    } catch (err) {}
    var href = link.href;
    window.setTimeout(function () {
      window.location.href = href;
    }, hold);
  });

  // warm the sounds on first touch so the bark starts with the tap, and reset after a Back navigation
  document.addEventListener(
    'pointerdown',
    function (event) {
      var link = event.target.closest && event.target.closest('a[href]');
      if (!link) return;
      var character = characterFor(link);
      if (character && character !== 'none') audio(soundFor(character));
    },
    { passive: true }
  );
  window.addEventListener('pageshow', clear);
})();
